import React from 'react';
import dayjs from 'dayjs';
import { ListingExclusion } from '@ha/api/v2/types/Listing';
import { DATE_RANGE_FORMAT } from 'ha/constants/Dates';
import { NO_END, NO_START } from '@ha/date';
import { useIntl } from 'ha/i18n';

const useRentalPeriod = (exclusions: ListingExclusion[]) => {
  const { formatDate } = useIntl();
  const elligiblePeriods = React.useMemo(
    () =>
      exclusions
        ? exclusions.filter(period =>
            dayjs(period.to).isAfter(dayjs(new Date())),
          )
        : [],
    [exclusions],
  );

  const bookedPeriods = React.useMemo(
    () => elligiblePeriods.filter(period => period.source === 'booking'),
    [elligiblePeriods],
  );

  const getPeriod = (period: { to: string; from: string }) => {
    let blockedPeriodText: string;
    if (period.to === NO_END) {
      blockedPeriodText = formatDate(DATE_RANGE_FORMAT, period.from);
    } else if (period.from === NO_START) {
      blockedPeriodText = `${formatDate(
        DATE_RANGE_FORMAT,
        new Date().toISOString(),
      )} - ${formatDate(DATE_RANGE_FORMAT, period.to)}`;
    } else {
      blockedPeriodText = `${formatDate(
        DATE_RANGE_FORMAT,
        period.from,
      )} - ${formatDate(DATE_RANGE_FORMAT, period.to)}`;
    }
    return blockedPeriodText;
  };

  return { getPeriod, bookedPeriods };
};

export { useRentalPeriod };
